import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import CloseButton from './Common/CloseButton';
import NodeDeleteConfirmationDialog from './Common/NodeDeleteConfirmationDialog';

const WorkflowConfirmDialogs = ({
  replayOpen,
  onReplayClose,
  onReplayConfirm,
  deleteOpen,
  onDeleteClose,
  onDeleteConfirm,
  deleteTitle = null,
  deleteQuestion = null,
  deleteSubject = null,
  deleteWarning = null,
  deleteConfirmLabel = null,
  t,
}) => (
  <>
    <Dialog
      open={replayOpen}
      onClose={onReplayClose}
      PaperProps={{ sx: { borderRadius: 3, boxShadow: 10 } }}
    >
      <DialogTitle sx={{
        bgcolor: 'warning.main',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pr: 1
      }}>
        {t('workflow.replay_confirm_title', 'Confirm Replay All')}
        <CloseButton
          ariaLabel="close"
          onClick={onReplayClose}
          sx={{ color: 'white' }}
        />
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mt: 2 }}>
          <Typography variant="body1" fontWeight="bold" paragraph>
            {t('workflow.replay_confirm_question', 'Are you sure you want to replay all workflows?')}
          </Typography>
          <Typography variant="body2" paragraph color="text.secondary">
            {t('workflow.replay_confirm_warning', 'This will re-execute all enabled actions for all events in this project. This may take some time and could overwrite existing data if actions modify files.')}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
        <Button onClick={onReplayClose} variant="outlined">
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button onClick={onReplayConfirm} variant="contained" color="warning">
          {t('workflow.replay_confirm_proceed', 'Proceed')}
        </Button>
      </DialogActions>
    </Dialog>

    <NodeDeleteConfirmationDialog
      open={deleteOpen}
      onClose={onDeleteClose}
      onConfirm={onDeleteConfirm}
      title={deleteTitle || t('settings.delete_confirm_title')}
      question={deleteQuestion || t('settings.delete_confirm_question', 'Are you sure you want to delete this workflow item?')}
      subject={deleteSubject || ''}
      description={deleteWarning === false
        ? ''
        : deleteWarning || t('settings.delete_confirm_warning', 'This action cannot be undone.')}
      cancelLabel={t('common.cancel', 'Cancel')}
      deleteLabel={deleteConfirmLabel || t('common.delete', 'Delete')}
    />
  </>
);

export default WorkflowConfirmDialogs;
